import { render, staticRenderFns } from "./dialog-multiresend.vue?vue&type=template&id=f8d35b7c&"
import script from "./dialog-multiresend.vue?vue&type=script&lang=js&"
export * from "./dialog-multiresend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports